import axios from 'axios';
import CryptoJS from "crypto-js";

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const SECRET = process.env.REACT_APP_CRYPTO_SECRET;

if (!SECRET) {
  throw new Error("❌ REACT_APP_CRYPTO_SECRET missing in .env");
}



const adminAxios = axios.create({ baseURL: `${API_URL}/admin` });




const key = CryptoJS.SHA256(SECRET);
const iv = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// 🔐 ENCRYPT
const encrypt = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return { data: encrypted.toString() };
};

// 🔓 DECRYPT
const decrypt = (payload) => {
  const decrypted = CryptoJS.AES.decrypt(
    payload.data,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};


// ===============================
// 🔐 REQUEST INTERCEPTOR
// ===============================
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 🔥 ENCRYPT BODY
  if (config.data && Object.keys(config.data).length > 0) {
    const encrypted = encrypt(config.data);

    config.headers['x-encrypted-data'] = JSON.stringify(encrypted);
    config.data = {};
  }

  return config;
});


// ===============================
// 🔐 RESPONSE INTERCEPTOR
// ===============================

adminAxios.interceptors.response.use(
  (response) => {
    try {
      // ✅ NEW: body based decrypt
      if (response.data?.encrypted) {
        const decrypted = decrypt(response.data.data);
        response.data = JSON.parse(decrypted);
      }
    } catch (err) {
      console.error("❌ Decryption failed:", err.message);
    }

    return response;
  },
  (error) => Promise.reject(error)
);


// ==========================================
// 🔐 AUTH & DASHBOARD ROUTES
// ==========================================
export const adminLogin = (data) => adminAxios.post('/login', data);
export const getDashboardStats = () => adminAxios.get('/dashboard');


// ==========================================
// 👥 USER MANAGEMENT ROUTES (Candidates, Casting Directors, etc.)
// ==========================================
export const getAdminUsers = (roleCode) => adminAxios.get(`/users/${roleCode}`);
export const createAdminUser = (data) => adminAxios.post('/users', data);
export const updateAdminUser = (id, data) => adminAxios.put(`/users/${id}`, data);
export const deleteAdminUser = (id) => adminAxios.delete(`/users/${id}`);
export const suspendAdminUser = (id) => adminAxios.patch(`/users/${id}/suspend`);



// ==========================================
// 📁 PROJECT MANAGEMENT ROUTES
// ==========================================
export const getAdminProjects = () => adminAxios.get('/projects');
export const getAdminProjectById = (id) => adminAxios.get(`/projects/${id}`);
export const createAdminProject = (data) => adminAxios.post('/projects', data);
export const updateAdminProject = (id, data) => adminAxios.put(`/projects/${id}`, data);
export const deleteAdminProject = (id) => adminAxios.delete(`/projects/${id}`);
export const toggleProjectStatus = (id) => adminAxios.patch(`/projects/${id}/toggle-status`);


// ==========================================
// 🎭 ROLE MANAGEMENT ROUTES
// ==========================================
export const getAdminRoles = () => adminAxios.get('/roles');
export const getAdminRoleById = (id) => adminAxios.get(`/roles/${id}`);
export const createAdminRole = (data) => adminAxios.post('/roles', data);
export const updateAdminRole = (id, data) => adminAxios.put(`/roles/${id}`, data);
export const deleteAdminRole = (id) => adminAxios.delete(`/roles/${id}`);
export const toggleRoleStatus = (id) => adminAxios.patch(`/roles/${id}/toggle-status`);

// ==========================================
// 🎭 LookUp
// ==========================================


export const getAdminLookups = () => adminAxios.get('/lookups/list');
export const saveAdminLookup = (data) => adminAxios.post('/lookups/save', data);
export const deleteAdminLookup = (groupName) =>
  adminAxios.delete(`/lookups/${groupName}`);


export const fetchContactSubmissionsApi = () => adminAxios.get('/contact');
export const fetchContactSubmissionDetailsApi = (id) => adminAxios.get(`/contact/${id}`);

export const getAdminAuditions = () => adminAxios.get('/audition-list');

export const getNotificationLogs = () =>  adminAxios.get("/notification-logs");

//  --- Cost Pricing --- //
export const fetchCosts = async () => { const res = await adminAxios.get('/cost-list');
  return res.data;
};
export const fetchCostById = async (name) => { const res = await adminAxios.get(`/cost/${name}`);
  return res.data;
};
export const createCost = (data) => adminAxios.post('/cost-save', data);
export const updateCost = (name, data) => adminAxios.post('/cost-save', data);
export const deleteCost = (name) =>  adminAxios.delete(`/cost/${name}`);
export const getCostTypes = async () => {  const res = await adminAxios.get('/cost-types');
  return res.data;
};
export const fetchCostOptions = async (type) => { const res = await adminAxios.get(`/cost-options/${type}`);
  return res.data;
};


export const getAllCoupons = () => adminAxios.get('/coupons/list');
export const getCouponById = (id) => adminAxios.get(`/coupons/details/${id}`);
export const createCoupon = (data) => adminAxios.post('/coupons/create', data);
export const updateCoupon = (id, data) => adminAxios.put(`/coupons/update/${id}`, data);
export const deleteCoupon = (id) => adminAxios.delete(`/coupons/delete/${id}`);
export const redeemCoupon = (code, userId) => adminAxios.post('/coupons/redeem', { code, userId });


export { adminAxios };
export default adminAxios; 